var icon = require('vue-svgicon')
icon.register({
  'n_current-position': {
    width: 16,
    height: 16,
    viewBox: '0 0 68 68',
    data: '<g><path d="M31.49,45.71c-7.85,0-14.2-6.36-14.2-14.21c0-7.85,6.35-14.21,14.2-14.21s14.22,6.36,14.22,14.21C45.71,39.35,39.34,45.71,31.49,45.71z"/></g>'
  }
});